import React from 'react';
import Icon from "../icon/info";
import { STYLE_PREFIX } from "../const";
import "./style.less";
var Alert = function Alert(_ref) {
  var content = _ref.content;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "-custom-alert")
  }, /*#__PURE__*/React.createElement(Icon, null), /*#__PURE__*/React.createElement("span", null, content));
};
export default Alert;